module.exports = __webpack_public_path__ + "img/moon.a9cb5235.svg";